var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('byted-button',{class:[( _obj = {}, _obj['is-loading'] = _vm.loading, _obj ), "common_popup_confirm"],attrs:{"type":"primary","loading":_vm.loading,"disabled":_vm.disabled},on:{"click":_vm.handleConfirm}},[_vm._v("\n  "+_vm._s(_vm.$t('common_confirm'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }